import React from 'react';
import {
    Content,
    NavBar,
    // Header
} from './index';

const Layout = () => {
    return (
        <div className="app-layout">
            <NavBar />
            <div className="c-wrapper">
                {/* <Header /> */}
                <div className="c-body">
                    <Content />
                </div>
            </div>
        </div>
    )
}

export default Layout;
